import { useNavigate, useParams } from "react-router-dom";
import secondaryComponents from "../../../components/secondaryComponents";
import { pathConstants } from "../../../routes/pathContants";
import { CheckoutView } from "../../../components/secondaryComponents/SellModeItemsV2";

export const BillCheckoutContinuation = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();

  return (
    <secondaryComponents.Modal
      isActive={true}
      width={1300}
      padding={"0"}
      style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      closeModal={() => navigate(pathConstants.SELL_MODE({ store_id }))}
    >
      <CheckoutView />
    </secondaryComponents.Modal>
  );
};
